export default __webpack_public_path__ + "static/media/whatsapp.89481620.svg";